import { render, staticRenderFns } from "./user_menu_upgrade_subscription.vue.js?vue&type=template&id=728fbd98!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_upgrade_subscription.vue?vue&type=template&id=728fbd98"
import script from "./user_menu_upgrade_subscription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_upgrade_subscription.vue?vue&type=script&lang=js"
export * from "./user_menu_upgrade_subscription.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_upgrade_subscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728fbd98')) {
      api.createRecord('728fbd98', component.options)
    } else {
      api.reload('728fbd98', component.options)
    }
    module.hot.accept("./user_menu_upgrade_subscription.vue.js?vue&type=template&id=728fbd98!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_menu_upgrade_subscription.vue?vue&type=template&id=728fbd98", function () {
      api.rerender('728fbd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/super_sidebar/components/user_menu_upgrade_subscription.vue"
export default component.exports